import { render, staticRenderFns } from "./DailyStudy.vue?vue&type=template&id=040f572e&scoped=true"
import script from "./DailyStudy.vue?vue&type=script&lang=ts"
export * from "./DailyStudy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f572e",
  null
  
)

export default component.exports